export default {
    yourTree: 'Tvoj JSON tree',
    addRootItem: 'Vytvor hlavnú položku',
    addItemtoRoot: 'Pridať položku',
    pasteInRootItem: 'Prilepiť do hlavnej položky',
    insertCode: 'Vlož JSON',
    searchPropOrValue: 'Vyhľadaj property name alebo value',
    selectAllItems: 'Vyznač všetky položky',
    unSelectAllItems: 'Odznač všetky položky',
    openAllItems: 'Otvor všetky položky',
    closeAllItems: 'Zatvor všetky položky',
    itemMenu: {
        title: 'Nastavenia',
        open: 'Otvor všetky podpoložky',
        close: 'Zatvor všetky podpoložky',
        add: 'Pridať podpoložku',
        edit: 'Upraviť položku',
        copy: 'Kopírovať',
        paste: 'Prilepiť',
        remove: 'Zmazať'
    },
    editItem: {
        title: 'Upraviť položku',
        propName: 'Názov položky',
        propType: 'Typ položky',
        selectOptions: 'Vyberte z možností',
        propOutputType: 'Výstupný typ položky',
        propValue: 'Hodnota položky',
    },
    outputFormatted: 'Sformátovaný výstup'
}
